// src/components/ShortMessage.js
import React from 'react';
import { ArrowRight, Quote } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import '../styles/ShortMessage.scss';

const MessageSection = () => {
  const { t } = useTranslation();

  return (
    <section className="message-section">
      <div className="container">
        <div className="section-header">
          <span className="section-tag">{t('leadership_speaks')}</span>
          <h2>{t('leadership_heading')}</h2>
          <p>{t('leadership_subheading')}</p>
        </div>

        <div className="message-cards">
          {/* Director Card */}
          <article className="message-card director-card">
            <div className="image-container">
              <img
                src="/images/director.png"
                alt={`Director ${t('director_name')}`}
                className="profile-image"
                loading="lazy"
              />
              <div className="role-chip">{t('director_designation')}</div>
            </div>
            <div className="content">
              <Quote className="quote-mark" size={32} />
              <div className="profile-info">
                <h4>{t('director_name')}</h4>
                <div className="designation">{t('director_designation')}</div>
              </div>
              <p className="preview-text">
                {t('director_message')}
              </p>
              <a href="/director-message" className="read-more-link">
                <span>{t('read_full_address')}</span>
                <ArrowRight size={16} />
              </a>
            </div>
          </article>

          {/* Principal Card */}
          <article className="message-card principal-card">
            <div className="image-container">
              <img
                src="/images/principal.png"
                alt={`Principal ${t('principal_name')}`}
                className="profile-image"
                loading="lazy"
              />
              <div className="role-chip">{t('principal_designation')}</div>
            </div>
            <div className="content">
              <Quote className="quote-mark" size={32} />
              <div className="profile-info">
                <h4>{t('principal_name')}</h4>
                <div className="designation">{t('principal_designation')}</div>
              </div>
              <p className="preview-text">
                {t('principal_message')}
              </p>
              <a href="/principal-message" className="read-more-link">
                <span>{t('read_full_address')}</span>
                <ArrowRight size={16} />
              </a>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
};

export default MessageSection;
